
import api from "../utils/api";
import { DASHBOARD_BLOCKED_MESSAGE } from "../utils/dashboardAccess";
import { clearSuperAdmin, setSuperAdmin } from "./superAdminController";

/**
 * Persist a session. `client` is the account the dashboard should render;
 * for a super admin that is whichever client they are viewing, not the
 * operator, so everything downstream keeps reading "username"/"user" as usual.
 */
export const applyClientSession = (token, client, superAdmin = null) => {
  const stored = { ...client, tier: client.tier || "standard" };
  localStorage.setItem("token", token);
  localStorage.setItem("user", JSON.stringify(stored));
  localStorage.setItem("username", stored.username);
  setSuperAdmin(superAdmin);
  window.dispatchEvent(
    new CustomEvent("auth-change", { detail: { username: stored.username } }),
  );
  return stored;
};

export const loginUser = async (username, password) => {
  try {
    const response = await api.post("/signin", { username, password });
    if (response?.data?.client && response?.data?.token) {
      const superAdmin = response.data.super_admin || null;

      // Super admins are expected to open accounts whose dashboard is switched
      // off — that is usually why they are looking.
      if (!superAdmin && response.data.client.effective_dashboard_access === false) {
        const blockedError = new Error(DASHBOARD_BLOCKED_MESSAGE);
        blockedError.code = "DASHBOARD_BLOCKED";
        throw blockedError;
      }

      return applyClientSession(response.data.token, response.data.client, superAdmin);
    } else {
      console.error("Invalid login response:", response?.data);
      throw new Error("Invalid login response");
    }
  } catch (error) {
    console.error("Login error:", {
      message: error.message,
      code: error.code,
      status: error?.response?.status,
      responseData: error?.response?.data,
      request: error?.request && (error.request.url || error.request),
    });
    throw error;
  }
};


export const getStoredUser = () => {
  try {
    const storedUser = localStorage.getItem("user");
    if (!storedUser) return null;
    const parsed = JSON.parse(storedUser);
    return { ...parsed, tier: parsed.tier || "standard" };
  } catch (error) {
    console.error("Failed to parse stored user", error);
    return null;
  }
};

export const isPremiumUser = () => {
  const user = getStoredUser();
  return user?.tier === "premium";
};

export const logoutUser = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("username");
  clearSuperAdmin();
  sessionStorage.removeItem("login_location_asked");
  window.dispatchEvent(new CustomEvent("auth-change", { detail: { username: null } }));
};
